import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert, Checkbox, Form, Input, Radio, Card, Divider, Steps, Select, Tag, Image, Row, Col, List, Avatar, DatePicker, Dropdown, Button, Menu, Typography, Space } from 'antd';
import './index.css';
import Navbar from '../../layouts/navbar';
import Footer from '../../layouts/footer';
import Slider from "react-slick";
import { InfoCircleOutlined, CalendarOutlined, CreditCardOutlined, SolutionOutlined, WifiOutlined, CheckCircleOutlined, CheckOutlined, EnvironmentOutlined, MessageOutlined, LikeOutlined, StarOutlined } from '@ant-design/icons';
import { AiOutlineWifi } from "react-icons/ai";
import { FaShower, FaSmokingBan } from "react-icons/fa";
import { RiWindyFill } from "react-icons/ri";
import Lottie from 'lottie-react-web';
import checkmark from '../../checkmark.json';
import failed from '../../failed.json';
import { useNavigate, useLocation } from 'react-router-dom';
import { mstAuth } from '../../mobx';
import axios from 'axios';
import { useReferral } from '../../utils/referral';

const { Text, Link, Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Step } = Steps;
const { TextArea } = Input;

const LoginScreen = observer((props) => {
	const {navigateWithReferral} = useReferral();
	const navProps = useLocation()
	const [currentStep, setCurrentStep] = useState(1)
	const [loggingIn, setLoggingIn] = useState(false)
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [errorMessage, setErrorMessage] = useState("")
	const [emailForgot, setEmailForgot] = useState("")

	console.log("check props LoginScreen ===> ", navProps !== null ? navProps : null)

	const onLogin = () => {
		setLoggingIn(true)
		mstAuth.login({ email: email, password: password })
		.then((response) => {
			mstAuth.fetchUserProfile({ UUID: response.UUID })
			.then((response) => {
				if (navProps.state?.action !== null) {
					setLoggingIn(false)
					navigateWithReferral('/reservation', { state: { action: "roomSelection", currentStep: 2, selectedRoom: navProps.state?.selectedRoom, selectedInfo: navProps.state?.selectedInfo }})
				} else {
					setLoggingIn(false)
					navigateWithReferral('/reservation')
				}
			})
			.catch((error) => {
				setLoggingIn(false)
				console.log(error)
			})
		})
		.catch((error) => {
			setLoggingIn(false)
			if (error.errorCode !== undefined) {
        setErrorMessage("[" + error.errorCode + "] " + error.errorMessage)
      } else if (error.error_code !== undefined) {
      	setErrorMessage("[" + error.error_code + "] " + error.error_message)
      } else {
      	setErrorMessage(error.toString())
      }
		})
	};

	const onForgotPassword = () => {
		setCurrentStep(2)
	};

	const onForgot = () => {
		const params = {
			email: emailForgot
		}
		mstAuth.forgotPassword(params)
		.then((response) => {
			alert("Successfully sent to your email")
		})
		.catch((error) => {
			alert(`[${error.error_code}] ${error.error_message}`)
		})
	};

	const onChangeInput = (type, event) => {
		console.log("Check onChangeInput ===> ", type, event.target.value)
		if (type === 'email') {
			setEmail(event.target.value)
		} else if (type === 'password') {
			setPassword(event.target.value)
		} else if (type === 'emailForgot') {
			setEmailForgot(event.target.value)
		}
	};	

	return (
		<div id="LoginScreen">
			<div className="container">
				<Navbar />
				{
					currentStep === 1 ?
					(
						<React.Fragment>
							<div className="pageTitleWrapper">
				      	<Text className="pageTitle">Login</Text>
				      </div>
				      <Divider className="pageTitleDivider" />
				      {
								errorMessage !== "" ?
								(
									<Alert
										message={errorMessage}
										type="error"
										closeable
										style={{ marginTop: '1em' }}
									/>
								)
								:
								(
									null
								)
							}
				      <Form
					      name="basic"
					      labelCol={{ span: 24 }}
					      wrapperCol={{ span: 24 }}
					      initialValues={{ remember: true }}
					      style={{ marginTop: '1em' }}
					      // onFinish={onFinish}
					      // onFinishFailed={onFinishFailed}
					      autoComplete="off"
					    >
					      <Form.Item
					        label="Email"
					        name="email"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input
					        	onChange={(e) => { onChangeInput("email", e) }}
					        />
					      </Form.Item>

					      <Form.Item
					        label="Password"
					        name="password"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input.Password
					        	onChange={(e) => { onChangeInput("password", e) }}
					        />
					      </Form.Item>
					     
					     	<Form.Item>
					      	<Link onClick={() => { onForgotPassword() }}>Forgot Password?</Link>
					      </Form.Item>

					      <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
					        <Button type="primary" htmlType="submit" loading={loggingIn} onClick={() => { onLogin() }}>
					          Login
					        </Button>
					        <Button type="link" onClick={() => { navigateWithReferral('/reservation/register') }}>
					          Create an Account
					        </Button>
					      </Form.Item>
					    </Form>
						</React.Fragment>
					)
					:
					(
						<React.Fragment>
							<div className="pageTitleWrapper">
				      	<Text className="pageTitle">Forgot Password</Text>
				      </div>
				      <Divider className="pageTitleDivider" />
				      <Form
					      name="basic"
					      labelCol={{ span: 24 }}
					      wrapperCol={{ span: 24 }}
					      initialValues={{ remember: true }}
					      style={{ marginTop: '1em' }}
					      // onFinish={onFinish}
					      // onFinishFailed={onFinishFailed}
					      autoComplete="off"
					    >
					      <Form.Item
					        label="Email"
					        name="email"
					        rules={[{ required: true, message: 'Required' }]}
					      >
					        <Input onChange={(e) => { onChangeInput("emailForgot", e) }} />
					      </Form.Item>
					     
					      <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
					        <Button type="primary" htmlType="submit" onClick={() => { onForgot() }}>
					          Submit
					        </Button>
					        <Button type="link" onClick={() => { setCurrentStep(1) }}>
					          Back to Login
					        </Button>
					      </Form.Item>
					    </Form>
						</React.Fragment>
					)
				}
	    </div>
	    <Footer />
		</div>
	)
});

export default LoginScreen;